'use es6';

import { createContext } from 'react';
export var OpenPopupContext = /*#__PURE__*/createContext({
  positionChannel: null
});